export default "__VITE_ASSET__aa9794f5__"